import React from 'react';
import PropTypes from 'prop-types';
import WaitingListCheckbox from './waitingListCheckbox';

const WaitingListCheckboxGroup = ({ sites, onChange, checked }) => {
  const checkboxes = [];

  const onCheckboxSelected = ev => {
    const isChecked = !!ev.target.checked;
    const checkboxId = ev.target.name;
    let site = '';

    if (isChecked) {
      site = checkboxId;
    }
    onChange(site);
  };

  sites.forEach(site => {
    const isChecked = site === checked;
    checkboxes.push(
      <WaitingListCheckbox
        key={site}
        checkboxClass="waiting-list__checkbox"
        checkboxName={site}
        checkboxLabel={site}
        checkboxOnChange={onCheckboxSelected}
        checked={isChecked}
      />
    );
  });
  return checkboxes;
};

WaitingListCheckboxGroup.propTypes = {
  sites: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default WaitingListCheckboxGroup;
